import Vue from 'vue';

import apiAxios from './https';
import {
  width
} from './config';
import qs from 'qs';


Vue.use(qs, apiAxios.install(Vue));


(function () {
  const a = {};
  a.width = width;
  a.fontSize = width / 19.2;
  a.widthProportion = () => {
    const b = (document.body.clientWidth || document.getElementsByTagName('html')[0].offsetWidth) / a.width;
    return b > 1 ? 1 : b;
  };
  a.changePage = () => {
    document.getElementsByTagName('html')[0].setAttribute('style', `font-size:${a.widthProportion() * a.fontSize}px !important`);
  };
  a.changePage();
  window.addEventListener('resize', () => {
    a.changePage();
  }, !1);
}());



// WEBPACK FOOTER //
// ./src/service/index.js